import { Injectable } from '@angular/core';

import { DisplayDatePipe } from '@open-portal-app/core/pipes/display-date.pipe';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PolicyPersonnelService {
  constructor(
    private displayDatePipe: DisplayDatePipe
  ) { }
  
  authorisedPersons(persons: any[], isRaptor: boolean) {
    const formattedPersonsList: any[] = [];
    
    if (persons && persons.length > 0) {
        persons.forEach((person: any) => {
            formattedPersonsList.push({
                name: PolicyPersonnelService.getPersonName(person, isRaptor),
                description: this.getPersonDob(person, isRaptor)
            });
        });
    }
    return formattedPersonsList;
  }

  static getPersonName(person: any, isRaptor: boolean) {
    if (isRaptor) {
      return `${person.other_authorised_contact_given_name} ${person.other_authorised_contact_last_name}`;
    }
    return `${person.first_name} ${person.last_name}`;
  }

  getPersonDob(person: any, isRaptor: boolean) {
    if (isRaptor) {
      return person.human_other_authorised_contact_dob;
    }
    return this.displayDatePipe.transform(person.dob, 'dd MMM yyyy');
  }
}